define('../app/fukit/view/block/saveable.sidebar.view',['require','exports','module','underscore','../../blockit.shared','uikit/uikit','../../helpers/factory','../../helpers/extend.util','./grid.container.view','../../behavior/modal.save.button.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      BlocKit                 = require('../../blockit.shared'),
      UIKit                   = require('uikit/uikit'),
      Factory                 = require('../../helpers/factory'),
      ExtendUtil              = require('../../helpers/extend.util'),
      GridContainerView       = require('./grid.container.view'),
      ModalSaveButtonBehavior = require('../../behavior/modal.save.button.behavior');

  var SaveableSidebarView = UIKit.Sidebar2.extend({
    options: _.extend({}, UIKit.Sidebar2.prototype.options, {
      width: 'wide',
    }),

    internalViewOptions: UIKit.Sidebar2.extendInternalViewOptions({
      actionsView: ExtendUtil.extendOptionValueWithDefaults('actions', {
        components: [
          {
            type: GridContainerView,
            spacing: 'uptight',
            components: [
              {
                content: {
                  type: UIKit.Sidebar2.DenyButtonView,
                  fluid: true,
                  text: 'Cancel',
                },
              },
              {
                content: Factory.saveButton({
                  model: '@model',
                  fluid: true,
                  behaviors: {
                    ModalSaveButtonBehavior: {
                      behaviorClass: ModalSaveButtonBehavior,
                    },
                  },
                }),
              },
            ],
          },
        ],
      }),
      contentView: function() {
        //prettier-ignore
        var content    = Mn._getValue(this.getOption('content'), this),
            components = content && content.components ? content.components : [];
        var messagesComponent = {
          type: UIKit.Message,
          name: 'messagesComponent',
          behaviors: {
            ResourceErrorsBehavior: _.extend({}, this.getOption('resourceErrorsOptions'), {
              ignoreAllControllerResources: true,
              behaviorClass: BlocKit.ResourceErrorsBehavior,
            }),
          },
        };

        return _.extend({}, content, {
          components: _.union([messagesComponent], components),
        });
      },
    }),
  });

  module.exports = SaveableSidebarView;
});

